import bannerEssential from '@/assets/banner-essential-img.png';
import { ApplicationState } from '@/store';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import './style.scss';

const EssentialHeader: React.FC = () => {
    const { strings, listLoading, totalListTraining, totalListToExpire, programLoading, totalProgramTraining, totalProgramToExpire } = useSelector(
        (state: ApplicationState) => ({
            strings: state.locale.data,
            listLoading: state.lists.listData.listEssentialStudentView.loading,
            totalListTraining: state.lists.listData.listEssentialStudentView.total,
            totalListToExpire: state.lists.listData.listEssentialStudentView.totalToExpire,
            programLoading: state.program.listData.listEssentialStudentView.loading,
            totalProgramTraining: state.program.listData.listEssentialStudentView.total,
            totalProgramToExpire: state.program.listData.listEssentialStudentView.totalToExpire,
        }),
    );

    const [totalTraining, setTotalTraining] = useState<number>(0);

    const [aboutToExpire, setAboutToExpire] = useState<number>(0);

    const isTotalsLoaded: boolean = !listLoading && !programLoading && (totalListTraining > 0 || totalProgramTraining > 0);

    useEffect(() => {
        if (isTotalsLoaded) {
            setTotalTraining(totalListTraining + totalProgramTraining);
            setAboutToExpire(totalListToExpire + totalProgramToExpire);
        }
    }, [isTotalsLoaded]);

    return (
        <>
            {isTotalsLoaded && (
                <div className="essential-header">
                    <h2 className="title">{strings.ESSENTIAL_SECTION.ESSENTIALS}</h2>

                    <div className="banner-container">
                        <div className="banner-info">
                            <div className="d-flex align-items-center">
                                <div className="training-info">
                                    <span className="training-amount">{totalTraining}</span>
                                    <span className="training-description">
                                        {totalTraining > 1
                                            ? strings.ESSENTIAL_SECTION.ESSENTIAL_TRAININGS
                                            : strings.ESSENTIAL_SECTION.ESSENTIAL_TRAINING}
                                    </span>
                                </div>
                                {aboutToExpire > 0 && (
                                    <span className="expiration-amount">{`${aboutToExpire} ${
                                        aboutToExpire === 1
                                            ? strings.ESSENTIAL_SECTION.ABOUT_TO_EXPIRE
                                            : strings.ESSENTIAL_SECTION.MANY_ABOUT_TO_EXPIRE
                                    }`}</span>
                                )}
                            </div>

                            <div className="d-flex flex-column mb-2">
                                <span className="banner-title">{strings.ESSENTIAL_SECTION.BANNER_TITLE}</span>
                                <span className="banner-description" dangerouslySetInnerHTML={{ __html: strings.ESSENTIAL_SECTION.BANNER_INFO }} />
                            </div>
                        </div>

                        <img alt={strings.ESSENTIAL_SECTION.ESSENTIAL_TRAININGS} className="banner-img" src={bannerEssential} />
                    </div>
                </div>
            )}
        </>
    );
};

export default EssentialHeader;
